import React from 'react'
import Banner from '../Components/banner/Banner'
import CoinsTable from '../Components/CoinsTable'
const Homepage = () => {
  return (
    <>
      <Banner/>
      <CoinsTable/>
    </>
  )
}

export default Homepage
